// extracted by mini-css-extract-plugin
export default {"button":"SignInButton_button__7quk5"};